// 这是文档页面的入口文件，用于渲染文档页面的路由和组件

import React, { Suspense } from 'react';
import { renderRoutes } from 'react-router-config';
import routes from './routes';
import { AppWrapper, renderApp } from '@/utils/createApp';
import { getBaseName } from '@/utils';
import GLoading from '@/component/Loading';
import { homeStore, storeContext } from '@/pages/home/models/store';
import { isMobile } from '@/utils/common';

// 手机端访问添加 mobile
if (isMobile()) {
  document.body.classList.add('mobile');
}

const App = () => (
  <Suspense fallback={<GLoading />}>
    {renderRoutes(routes)}
  </Suspense>
);

const hotModule = module as any;
if (hotModule.hot) {
  hotModule.hot.accept();
}

const basename = getBaseName('docs-page');

renderApp(<AppWrapper
  baseName={basename}
  Component={App}
  title="API Documentation"
  spaContext={storeContext}
  spaStore={homeStore}
/>, document.getElementById('root')!);
